import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';

import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';
import { TranslatePipe } from '@ngx-translate/core';

export type RequireDescriptionAcknowledgementAgainDialogResult = boolean | undefined;

@Component({
  selector: 'proffeo-require-description-acknowledgement-again-dialog',
  templateUrl: './require-description-acknowledgement-again-dialog.component.html',
  imports: [UiButtonComponent, MatDialogModule, UiDialogComponent, TranslatePipe]
})
export class RequireDescriptionAcknowledgementAgainDialogComponent {
  private readonly dialogRef =
    inject<
      MatDialogRef<
        RequireDescriptionAcknowledgementAgainDialogComponent,
        RequireDescriptionAcknowledgementAgainDialogResult
      >
    >(MatDialogRef);

  protected close(requireConfirmationAgain: boolean): void {
    this.dialogRef.close(requireConfirmationAgain);
  }
}
